export enum GameStatus {
    AVAILABLE = 'AVAILABLE',
    COMING = 'COMING',
    DISABLED = 'DISABLED',
}
